import { useMemo } from 'react'
import { ToastProps, TransitionState } from 'react-toast-notifications'

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle'
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle'
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle'
import clsx from 'clsx'

import { Message, MessageProps } from '@infura/packages.ui/Message'

const CustomToast = ({ appearance, children, onDismiss, transitionState }: ToastProps) => {
  const theme = useMemo<MessageProps['theme']>(() => {
    switch (appearance) {
      case 'error':
        return 'danger'
      case 'info':
        return 'neutral'
      case 'warning':
        return 'warning'
      case 'success':
        return 'success'
      default:
        return 'neutral'
    }
  }, [appearance])

  const icon = useMemo<IconDefinition>(() => {
    switch (appearance) {
      case 'error':
        return faExclamationTriangle
      case 'info':
        return faInfoCircle
      case 'warning':
        return faInfoCircle
      case 'success':
        return faCheckCircle
      default:
        return faInfoCircle
    }
  }, [appearance])

  const toastStates: { [state in TransitionState]: string } = {
    entered: 'transform ease-out duration-300 transition translate-y-0 opacity-100 sm:translate-x-0',
    entering: 'transform ease-out duration-300 transition translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-12',
    exited: 'transition ease-in duration-100 opacity-0',
    exiting: 'transition ease-in duration-100 opacity-100'
  }

  return (
    <Message className={clsx('mb-2', toastStates[transitionState])} dismiss={onDismiss} icon={icon} theme={theme}>
      {children}
    </Message>
  )
}

export default CustomToast
